module.exports = __webpack_public_path__ + "img/more.9695d116.svg";